import request from './request';
import Vue from 'vue'

export function selectEffectiveBanners() {
  const url = '/banner/queryAllEffective';
  const options = {
    method: 'POST',
    url: url,
  };

  return request(options);
}

export function apiListPaidEvent() {
  const url = '/event/getPaidEventList';
  const options = {
    method: 'GET',
    url: url,
  };

  return request(options);
}

export async function apiGetEventByPerfId(perfId) {
  const url = '/event/getEvent?perfId=' + perfId
  const options = {
    method: 'GET',
    url: url,
  };

  return await request(options);
}

export function apiGetReport(url, event) {
  // const url = '/watchLog/report/duration';
  // const url = '/watchLog/report/activeViewer';
  const options = {
    method: 'POST',
    url: url,
    responseType: 'blob', // If you forget this, your download will be corrupt.
    data: event,
  };
  console.log(url)

  return request(options);
}

export function getMemberProfile () {
  var url = '/adminUser/profile'
  const options = {
    method: 'GET',
    url: url,
    withCredentials: true
  }

  return request(options)
}

export function apiGetCountryCode () {
  var url = '/api/data/countries'
  const options = {
    method: 'GET',
    url: url
  }

  return request(options)
}

export function apiVpnVideoList () {
  var url = '/api/vpnVideo/list'
  const options = {
    method: 'GET',
    url: url
  }

  return request(options)
}

export function apiVpnVideoSave (data) {
  var url = '/api/vpnVideo/save'
  const options = {
    method: 'POST',
    url: url,
    data: data
  }

  return request(options)
}

export function apiVpnVideoDelete (id) {
  var url = '/api/vpnVideo/delete?id=' + id
  const options = {
    method: 'DELETE',
    url: url
  }

  return request(options)
}

export function apiResendPaymentNotification (data) {
  var url = '/recon/paymentFeedback/resend'
  const options = {
    method: 'POST',
    url: url,
    data: data
  }

  return request(options)
}


export function apiListPaymentUser () {
  var url = 'recon/payment/user/list'
  const options = {
    method: 'GET',
    url: url,
    headers: {
      Authorization: Vue.prototype.$chatToken
    },
    withCredentials: true
  }

  return request(options)
}


export function apiSystemParameterList () {
  var url = '/api/systemParameter/selectAll'
  const options = {
    method: 'GET',
    url: url,
    withCredentials: true
  }

  return request(options)
}

export function apiSystemParameterUpdate(data) {
  var url = '/api/systemParameter/update'
  const options = {
    method: 'POST',
    url: url,
    withCredentials: true,
    data: data
  };

  return request(options);
}